import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.array.iterator.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { nsarchives } from "../../../../../i18n/namespaces";
import InputAutosize from 'react-18-input-autosize';
import { ViewerControlButton } from "../button";
import '@isyc-react/design/main';
import "./control-pagination.style.scss";
const getCurrentPage = (currentPage, numPages) => currentPage + 1 || (numPages ? 1 : '--');
const isNumeric = value => /^\d+$/.test(value);
const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
export const ViewerControlPagination = props => {
  const {
    currentPage,
    numPages,
    onChange
  } = props;
  const {
    t
  } = useTranslation(nsarchives.common);
  const [page, setPage] = React.useState(getCurrentPage(currentPage, numPages));
  React.useEffect(() => {
    setPage(getCurrentPage(currentPage, numPages));
  }, [currentPage, numPages]);
  const total = React.useMemo(() => numPages || '--', [numPages]);
  const onInputChangePage = React.useCallback(() => {
    if (isNumeric(page.toString())) {
      const current = parseInt(page.toString());
      let pageIndex = current - 1;
      const pages = numPages - 1;
      setPage(getCurrentPage(clamp(pageIndex, 0, pages), numPages));
      onChange && onChange(pageIndex);
    } else setPage(getCurrentPage(currentPage, numPages));
  }, [currentPage, page, numPages]);
  return /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center h-100"
  }, /*#__PURE__*/React.createElement(ViewerControlButton, {
    disabled: currentPage <= 0,
    onClick: () => onChange && onChange(currentPage - 1)
  }, /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-chevron-left"
  })), /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center"
  }, /*#__PURE__*/React.createElement(InputAutosize, {
    inputClassName: "control-pagination-current-page px-2",
    value: page,
    onBlur: () => onInputChangePage(),
    onKeyDown: e => {
      if (e.key === 'Enter') onInputChangePage();
    },
    onChange: e => setPage(e.target.value),
    maxLength: 5
  }), /*#__PURE__*/React.createElement("span", {
    className: "px-2"
  }, t('archive.view.controls.paginationOf')), /*#__PURE__*/React.createElement("span", {
    className: "px-2"
  }, total)), /*#__PURE__*/React.createElement(ViewerControlButton, {
    disabled: currentPage >= numPages - 1,
    onClick: () => onChange && onChange(currentPage + 1)
  }, /*#__PURE__*/React.createElement("i", {
    className: "mdi mdi-chevron-right"
  })));
};